import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import { CookieBanner } from './components/CookieBanner'
import { MainLayout } from './components/layout/MainLayout'
import { AcceptableUsePage } from './pages/AcceptableUsePage'
import { HomePage } from './pages/Home'
import { LocationDetail } from './pages/LocationDetail'
import { NotFoundPage } from './pages/NotFoundPage'
import { PrivacyPolicyPage } from './pages/PrivacyPolicy'
import { TermsPage } from './pages/TermsPage'
import { initSentry, triggerSentrySmokeTest } from './shared/lib/sentry'

initSentry()

if (typeof window !== 'undefined') {
  const searchParams = new URLSearchParams(window.location.search)
  if (searchParams.get('sentry_test_event') === '1') {
    triggerSentrySmokeTest()
  }
}

const queryClient = new QueryClient()

const router = createBrowserRouter([
  {
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/locations/:slug',
        element: <LocationDetail />,
      },
      {
        path: '/privacy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: '/terms',
        element: <TermsPage />,
      },
      {
        path: '/acceptable-use',
        element: <AcceptableUsePage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <CookieBanner />
    </QueryClientProvider>
  </StrictMode>,
)
